export const namoNetraConsultationCreateTranslations = {
    en: {
        submitSuccess: "consultation added successfully!",
        submitFailed: "consultation Failed to add",
        submitting: "Submitting...",
        submit: "Save Screening Details",

        patientInformation: "Patient Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No e.g. 00005",
        beneficiaryName: "Beneficiary Name",
        fetchOpdFailed: "Failed to fetch OPD numbers!",

        complaintsCard: "Complaints, Findings and Observations",
        complaints: "Beneficiary Complaints / Symptoms",
        complaintsPlaceholder: "Enter Beneficiary Complaints / Symptoms",
        findings: "Findings And Observations / Provisional Diagnosis",
        findingsPlaceholder: "Enter Findings And Observations",

        referralInformation: "Referral Information",
        selectAtLeastOne: "Select at least one Referral Type",

        refractiveCard: "Refractive Referral Vision Details",
        visionDetails: "Vision Details",
        visionRe: "Vision at 6m (RE)",
        visionLe: "Vision at 6m (LE)",
        nearAdd: "Near Add",
        glassesPrescription: "Glasses Prescription",

        diagnosticCard: "Diagnostic Referral",
        diagnosticReferral: "Diagnostic Referral",
        diagnosticPlaceholder: "Select Diagnostic Referral",
        otherDiagnostic: "Other Diagnostic Referral",
        otherDiagnosticPlaceholder: "Enter Other Diagnostic Referral",

        therapeuticCard: "Therapeutic Referral",
        therapeuticReferral: "Therapeutic Referral",
        therapeuticPlaceholder: "Select Therapeutic Referral",
        otherTherapeutic: "Other Therapeutic Referral",
        otherTherapeuticPlaceholder: "Enter Other Therapeutic Referral",

        otherReferCard: "Referral Note for Other",
        isOtherRefer: "Is Other Refer",
        yes: "Yes",
        no: "No",
        selectHospital: "Select Hospital",
        selectHospitalPlaceholder: "Select Hospital",
        otherHospital: "Other Hospital",
        otherHospitalName: "Other Hospital Name",
        otherHospitalPlaceholder: "Other Hospital Name",
        referalNotes: "Referal Notes For Other",
        referalNotesPlaceholder: "Enter Referal Notes",

        refractive: "Refractive",
        diagnostic: "Diagnostic Referral",
        therapeutic: "Therapeutic Referral / Cataract / Surgery",
        pharmacy: "Pharmacy",
    },
    mr: {
        submitSuccess: "नमो नेत्र तपासणी यशस्वीरित्या जोडली!",
        submitFailed: "नमो नेत्र तपासणी जोडण्यात अयशस्वी!",
        submitting: "सबमिट करत आहे...",
        submit: "तपासणी तपशील जतन करा",

        patientInformation: "रुग्ण माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",

        complaintsCard: "तक्रारी, निष्कर्ष आणि निरीक्षणे",
        complaints: "लाभार्थी तक्रारी / लक्षणे",
        complaintsPlaceholder: "लाभार्थी तक्रारी / लक्षणे टाका",
        findings: "निष्कर्ष आणि निरीक्षणे / प्राथमिक निदान",
        findingsPlaceholder: "निष्कर्ष आणि निरीक्षणे टाका",

        referralInformation: "संदर्भ माहिती",
        selectAtLeastOne: "किमान एक संदर्भ प्रकार निवडा",

        refractiveCard: "अपवर्तक संदर्भ दृष्टी तपशील",
        visionDetails: "दृष्टी तपशील",
        visionRe: "६ मीटर वर दृष्टी (उजवा डोळा)",
        visionLe: "६ मीटर वर दृष्टी (डावा डोळा)",
        nearAdd: "Near Add",
        glassesPrescription: "चष्मा प्रिस्क्रिप्शन",

        diagnosticCard: "निदान संदर्भ",
        diagnosticReferral: "निदान संदर्भ",
        diagnosticPlaceholder: "निदान संदर्भ निवडा",
        otherDiagnostic: "इतर निदान संदर्भ",
        otherDiagnosticPlaceholder: "इतर निदान संदर्भ टाका",

        therapeuticCard: "उपचारात्मक संदर्भ",
        therapeuticReferral: "उपचारात्मक संदर्भ",
        therapeuticPlaceholder: "उपचारात्मक संदर्भ निवडा",
        otherTherapeutic: "इतर उपचारात्मक संदर्भ",
        otherTherapeuticPlaceholder: "इतर उपचारात्मक संदर्भ टाका",

        otherReferCard: "इतर संदर्भ नोंद",
        isOtherRefer: "इतर ठिकाणी संदर्भित करायचे का?",
        yes: "होय",
        no: "नाही",
        selectHospital: "रुग्णालय निवडा",
        selectHospitalPlaceholder: "रुग्णालय निवडा",
        otherHospital: "इतर रुग्णालय",
        otherHospitalName: "इतर रुग्णालयाचे नाव",
        otherHospitalPlaceholder: "इतर रुग्णालयाचे नाव",
        referalNotes: "इतरांसाठी संदर्भ नोंदी",
        referalNotesPlaceholder: "संदर्भ नोंदी टाका",

        refractive: "अपवर्तक",
        diagnostic: "निदान संदर्भ",
        therapeutic: "उपचारात्मक संदर्भ / मोतीबिंदू / शस्त्रक्रिया",
        pharmacy: "औषधालय",
    },
};
